

















import { mdiDotsVertical } from '@mdi/js';
import Vue from 'vue';

export default Vue.extend({
    name: 'VideoActions',
    props: {
        video: {
            required: true,
        },
    },
    data: () => ({
        icons: {
            menu: mdiDotsVertical,
        },
    }),
    methods: {
        async remove() {
            await this.$store.dispatch('deleteVideo', {
                video: this.video,
                remote: true,
                local: true,
            });
        },
    },
});
